import Vue from 'vue';
import dayjs from 'dayjs';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
// import {setupDateSlider} from './_modules/date-slider.js';
import * as basicLightbox from 'basiclightbox'
// import BuyTicketsComponent from './_components/BuyTicketsComponent.vue';
// import cloneDeep from 'lodash/cloneDeep';

// dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

new Vue({
    el: "#homeBody",
    // components: {
    //     BuyTicketsComponent
    // },
    // mixins: [validationMixin],
    data: {
        // dates: dates,
        // dateSelected: null,
        movies: movies,
        // showingSelected: null,
        // ajaxPending: false,
        // view: null,
    },

    // computed: {
    //     moviesToday: function() {
    //         let vue = this;
    //         return vue.movies.filter(function(movie) {
    //             return movie.showings.some(function(showing) {
    //                 return vue.dateSelected.isSame(dayjs(showing.date), 'day');
    //             })
    //         })
    //     },
    //     moviesToShow: function() {
    //         return (this.view === this.Views.byDay)
    //             ? this.moviesToday
    //             : this.movies
    //         ;
    //     }
    // },

    methods: {
        // todays: function(showings) {
        //     let vue = this;
        //     return (this.view === this.Views.byDay)
        //         ? showings.filter(function(showing) {
        //             return vue.dateSelected.isSame(dayjs(showing.date), 'day');
        //         })
        //         : showings
        //     ;
        // },
        // showingDatesToShow: function(showingDates) {
        //     let vue = this;
        //     let dts = (this.view === this.Views.byDay)
        //         ? [showingDates.find(function(showingDate) {
        //             return vue.dateSelected.isSame(dayjs(showingDate.date), 'day');
        //         })]
        //         : showingDates
        //     ;
        //     console.debug(dts);
        //     return dts;
        // },
        // showBuyTickets: function(movie, showing) {
        //     showing = cloneDeep(showing);
        //     showing.movie = cloneDeep(movie);
        //     delete showing.movie.showingDates;
        //     this.showingSelected = showing;
        //
        //     let elm = document.getElementById('buyTickets');
        //     elm.classList.add('lightbox--visible');
        //     elm.focus();
        // },
        // hideBuyTickets: function() {
        //     this.showingSelected = null;
        // },
        // clickBuyTickets: function(evt) {
        //     if (evt.target.classList.contains('lightbox')) {
        //         evt.target.classList.remove('lightbox--visible');
        //     }
        // },
        showPosterLightbox: function(evt) {
            let src = evt.target.dataset.lightbox_src;
            (new Promise(function (resolve, reject) {
                let img = document.createElement('img');
                img.onload = function () {
                    resolve(src);
                };
                img.onerror = function () {
                    reject(src);
                };
                img.src = src;
            }))
                .then(function (src) {
                    let lb = basicLightbox.create('<img class="lightboxImage" src="' + src + '">');
                    lb.show();
                })
                .catch(function (err) {
                    console.error(err);
                })
            ;
        },
        showTrailer: function(slug, evt) {
            let movie = this.movies.find(elm => elm.slug === slug);
            evt.preventDefault();
            let iframe = `<div style="width: 90vw; height: 0; padding-bottom: 56%; margin: 0 auto;">
                <iframe style="position: absolute; width: 100%; height: 100%;" src="${movie.trailer}"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                ></iframe></div>`;
            basicLightbox.create(iframe).show();
        }
    },

    created: function() {
        // this.Views = {
        //     byDay: 1,
        //     byMovie: 2,
        // };
        // this.view = this.Views.byDay;
        //
        // this.dates.forEach(function(date, idx, arr) {
        //     arr[idx] = dayjs(date);
        // });
        // this.dateSelected = this.dates[0];
        // console.debug(this.movies);
        this.movies.forEach(function(movie, idxMovie, arrMovie) {
            // movie.showings.forEach(function(showing, idxShowing) {
            //     arrMovie[idxMovie].showings[idxShowing].shown_at = dayjs.utc(showing.shown_at, 'YYYY-MM-DD HH:mm:ss').local();
            // });
            movie.showingDates.forEach(function(showingDate, idxShowingDate) {
                arrMovie[idxMovie].showingDates[idxShowingDate].date = dayjs(showingDate.date, 'YYYY-MM-DD');
                showingDate.showings.forEach(function(showing, idxShowing) {
                    arrMovie[idxMovie].showingDates[idxShowingDate].showings[idxShowing].shown_at
                        = dayjs.utc(showing.shown_at, 'YYYY-MM-DD HH:mm:ss').local();
                });
            });
        });
    },
    // mounted: function() {
    //     setupDateSlider();
    // }
});
